class APIS {
	apis() {
		return {
			fetchCourses: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/course",
			},
			fetchQuizzes: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/quizzes",
			},
			fetchWebinarsnEvents: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/shareholder",
			},
			fetchArchiveWebinarsnEvents: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/archived/webinars",
			},
			register: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/backend/customer/signup",
			},
			login: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/backend/customer/login",
			},
			generateCertificate: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/download/certificate",
			},
			generateQuizResult: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/course/result",
			},
			checkUser: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/customer/course",
			},
			fetchPodcasts: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/shareholder",
			},
			fetchPresentations: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/shareholder",
			},
			fetchGovernanceUpdates: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/shareholder",
			},
		};
	}
}

export default new APIS();
